<script>
    import modalService from '@/services/core/modal.service';

    export default {
        props: {
            sizeClass: String,
            closeIcon: {
                type: Object,
                default: () => ({
                    hide: false,
                    height: null
                })
            }
        },
        data() {
            return {
                hasMounted: false
            };
        },
        computed: {
            isModalOpened() {
                return this.hasMounted;
            },
            getCloseButtonStyle() {
                const { height } = this.closeIcon || {};
                return height ? { height, lineHeight: height } : null;
            }
        },
        methods: {
            onClose() {
                if (typeof this.close === 'function') this.close();
                else modalService.closeModal(true);
            },
            onSuccess() {
                if (typeof this.success === 'function') this.success();
                else this.onClose();
            }
        },
        mounted() {
            setTimeout(() => {
                this.hasMounted = true;
            }, 50);
        }
    };
</script>

<template>
    <div class="modal" :class="{ 'modal-open': hasMounted }">
        <div :class="`modal-dialog ${sizeClass || ''}`" role="document">
            <div class="modal-content">
                <button v-if="!closeIcon.hide" class="btn btn-link modal-btn-close-icon" @click="onClose" :style="getCloseButtonStyle">
                    &times;
                </button>

                <slot />
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import '@/styles/_gsb-variables.scss';
    @import '~bootstrap/scss/functions';
    @import '~bootstrap/scss/variables';

    $modal-header-height: 4rem;

    .modal {
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        margin-right: auto;
        margin-left: auto;
        display: block;
        max-width: none;
        padding: 0;
        background-color: rgba(#000, 0.4);
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        opacity: 0;
        transition: all 0.3s ease;

        &.modal-open {
            opacity: 1;
        }

        .modal-dialog {
            &.modal-md-plus {
                @media (min-width: 576px) {
                    max-width: 600px !important;
                }
            }

            &.modal-lg {
                @media (min-width: 576px) {
                    max-width: 800px !important;
                }
            }
        }

        form {
            background-color: transparent;
        }

        .modal-body {
            background-color: white;
            padding: 0.75rem 2rem;
        }

        .modal-btn-close-icon {
            position: absolute;
            right: 0;
            top: 0;
            color: #444;
            font-size: 36px;
            z-index: 2;
            text-decoration: none;
            height: $modal-header-height;
            line-height: $modal-header-height;
            width: 40px;
            padding: 0;

            &:hover {
                opacity: 0.8;
            }
        }

        .modal-header {
            min-height: $modal-header-height;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-shrink: 0;
            position: relative;
            background-color: white;
            z-index: 1;

            .modal-title {
                width: 100%;
                margin: 0;
                color: #444;
                line-height: 1.3;
                text-align: center;
            }
        }

        .modal-footer {
            display: flex;
            justify-content: space-between;
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
            text-align: left;
            background-color: white;

            .btn {
                min-width: 85px;
                font-size: 1.3rem;
            }
        }

        @media (max-width: 767.98px) {
            .modal-dialog,
            .modal-content {
                height: 100%;
            }

            .modal-btn-close-icon {
                display: none;
            }

            .modal-dialog {
                max-width: none;
                margin: 0;
            }

            .modal-content {
                border-radius: 0;
            }

            .modal-body {
                max-height: none !important;
            }

            .modal-footer {
                display: none;
            }
        }
    }

    .gsb-readonly {
        pointer-events: none;

        .form-check-input:checked {
            background-color: $gray-600;
            border-color: $gray-600;
        }

        .form-control,
        .gsb-select select {
            background-color: $gray-100;
            color: $gray-600;
            border-color: $gray-300;
        }
    }

    @media (min-width: 768px) {
        .modal {
            -webkit-backdrop-filter: blur(1px);

            .modal-header {
                .back-btn,
                .action-btn {
                    display: none !important;
                }
            }

            .modal-dialog {
                margin-top: 3rem;
                margin-bottom: 3rem;
            }
        }
    }
</style>
